var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEmail, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class UserForSelectionDto {
    id;
    firstName;
    lastName;
    fullName;
    email;
    role;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], UserForSelectionDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UserForSelectionDto.prototype, "firstName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UserForSelectionDto.prototype, "lastName", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], UserForSelectionDto.prototype, "fullName", void 0);
__decorate([
    IsOptional(),
    IsEmail(),
    __metadata("design:type", String)
], UserForSelectionDto.prototype, "email", void 0);
__decorate([
    IsEnum(Role),
    __metadata("design:type", String)
], UserForSelectionDto.prototype, "role", void 0);
//# sourceMappingURL=user.for-selection.dto.js.map